import { Component, OnInit, Renderer2 } from '@angular/core';
import { LoginModel } from '../model/login.model';
import { NotafiscalService } from '../services/notafiscal.service';
import { IFrotaModel } from '../frota/model/frota.model';
import { SnackBarService } from '../services/snack-bar-service.service';
import { AuthenticationService } from '../services/authentication.service';
import { IArquiveiModel, IConsultaConfiguracaoNFe, IParametroConciliacao, IParametroReagendamento } from '../model/configuracaoNFe.model';
import { Subscription } from 'rxjs';
import {MatTabsModule} from '@angular/material/tabs';

@Component({
  selector: 'app-configuracao-nfe',
  templateUrl: './configuracao-nfe.component.html',
  styleUrls: ['./configuracao-nfe.component.scss']
})
export class ConfiguracaoNFeComponent implements OnInit {

  usuario!: LoginModel | undefined;

  private subs = new Subscription();

  loading = 0;

  codigoFrota: number | undefined | null;
  nomeReduzidoFrota: string | undefined | null;

  arquivei!: IArquiveiModel;

  parametroReagendamento!: IParametroReagendamento;
  parametroConciliacao!: IParametroConciliacao;

  constructor(
    private notaFiscalService: NotafiscalService,
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    // Liga a animação de Loading (Spinner) na tela
    this.loading++;

    this.usuario = this.notaFiscalService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.notaFiscalService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {

          this.iniciar();

        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });
  }

  private iniciar() {

    this.renderer.addClass(document.body, this.usuario?.retorno?.aparencia ?? 'PADRAO');
  }

  selecionaFrota(frota: IFrotaModel | null) {
    if (!frota || !frota.codigo) {
      this.codigoFrota = null;
    } else {
      this.codigoFrota = frota.codigo;
      this.nomeReduzidoFrota = frota.nomeReduzido;
      this.getArquivei();
      this.getParametroReagendamento();
      this.getParametroConciliacao();
    }
  }

  onChangeReagendamentoHabilitado(flagReagendamentoHabilitado: string) {

    if (flagReagendamentoHabilitado == "N") {
      this.parametroReagendamento.dataInicioOperacao = null;
      this.parametroReagendamento.dataInicioReagendamento = null;
      this.parametroReagendamento.tipoReagendamento = "1";
      this.parametroReagendamento.qtdeDiasAposFechamentoCiclo = null;
    }
  }

  private getArquivei() {
    if (!this.usuario?.retorno?.guid || !this.codigoFrota) {
      return;
    }

    const filtroContato: IConsultaConfiguracaoNFe = { guid: this.usuario.retorno.guid, codigoFrota: this.codigoFrota };
    this.loading++;

    this.subs.add(this.notaFiscalService.getArquivei(filtroContato)
      .subscribe({
        next: (res) => {
          if (res?.sucesso && res.retorno) {
            this.arquivei = res.retorno;
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  private getParametroReagendamento() {
    if (!this.usuario?.retorno?.guid || !this.codigoFrota) {
      return;
    }

    const filtroContato: IConsultaConfiguracaoNFe = { guid: this.usuario.retorno.guid, codigoFrota: this.codigoFrota };
    this.loading++;

    this.subs.add(this.notaFiscalService.getParametroReagendamento(filtroContato)
      .subscribe({
        next: (res) => {
          if (res?.sucesso && res.retorno) {
            this.parametroReagendamento = res.retorno;
            this.parametroReagendamento.tipoReagendamento = this.parametroReagendamento.qtdeDiasAposFechamentoCiclo == null ? "1" : "2";
            if (this.parametroReagendamento.habilitado == 'N') {
              this.parametroReagendamento.tipoReagendamento = "1";
              this.parametroReagendamento.dataInicioOperacao = null;
              this.parametroReagendamento.dataInicioReagendamento = null;
              this.parametroReagendamento.qtdeDiasAposFechamentoCiclo = null;
            }
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  private getParametroConciliacao() {
    if (!this.usuario?.retorno?.guid || !this.codigoFrota) {
      return;
    }

    const filtroContato: IConsultaConfiguracaoNFe = { guid: this.usuario.retorno.guid, codigoFrota: this.codigoFrota };
    this.loading++;

    this.subs.add(this.notaFiscalService.getParametroConciliacao(filtroContato)
      .subscribe({
        next: (res) => {
          if (res?.sucesso && res.retorno) {
            this.parametroConciliacao = res.retorno;
            if (this.parametroConciliacao.tipoConciliacao == 'C') {
              this.parametroConciliacao.valorFixoAceite = null;
            }
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  cancelarArquivei() {
    if (!this.usuario?.retorno?.guid || !this.codigoFrota) {
      return;
    }

    if (window.confirm('Favor remover os certificados digitais da frota no Portal antes de cancelar, deseja continuar com o cancelamento ?')) {
      this.loading++;
      const parametro: IConsultaConfiguracaoNFe = { guid: this.usuario.retorno.guid, codigoFrota: this.codigoFrota };
      this.subs.add(this.notaFiscalService.cancelarArquivei(parametro)
        .subscribe({
          next: (res) => {
            if (res?.sucesso) {
              this.snackBar.flashMessage('Arquivei cancelada com sucesso.', ['snackbar-info'], 'Fechar', 0);
            }
          },
          complete: () => {
            this.getArquivei();
            this.loading--;
          }
        }));

      
    }

  }

  onSubmitReagendamento(f: any): void {

    if (!f.form.valid) {
      this.snackBar.flashMessage('Favor corrigir os campos marcados.', ['snackbar-error'], 'Fechar', 0);
      return;
    }

    this.alterarParametroReagendamento()
  }

  alterarParametroReagendamento() {
    if (!this.usuario?.retorno?.guid || !this.codigoFrota) {
      return;
    }

    if (window.confirm('Confirma a alteração dos parâmetros para o Reagendamento e Upload de Notas Fiscas Eletrônicas ?')) {

      this.loading++;
      this.parametroReagendamento.guid = this.usuario.retorno.guid;
      this.subs.add(this.notaFiscalService.alterarParametroReagendamento(this.parametroReagendamento)
        .subscribe({
          next: (res) => {
            if (res?.sucesso) {
              this.snackBar.flashMessage('Parâmetros de reagendamento alterados com sucesso.', ['snackbar-info'], 'Fechar', 0);
            }
          },
          complete: () => {
            this.getParametroReagendamento();
            this.loading--;
          }
        }));
    }
  }

  alterarParametroConciliacao() {
    if (!this.usuario?.retorno?.guid || !this.codigoFrota) {
      return;
    }

    if (window.confirm('Confirma a alteração dos parâmetros da Conciliação de Notas Fiscas Eletrônicas ?')) {

      this.loading++;
      this.parametroConciliacao.guid = this.usuario.retorno.guid;
      this.subs.add(this.notaFiscalService.alterarParametroConciliacao(this.parametroConciliacao)
        .subscribe({
          next: (res) => {
            if (res?.sucesso) {
              this.snackBar.flashMessage('Parâmetros de conciliação alterados com sucesso.', ['snackbar-info'], 'Fechar', 0);
            }
          },
          complete: () => {
            this.getParametroConciliacao();
            this.loading--;
          }
        }));
    }
  }

}
